var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',{staticClass:"pa-0"},[_c('v-container',{staticClass:"pa-0",attrs:{"id":"main-container","fluid":""}},[(_vm.userLoaded)?_c('router-view',{key:_vm.$route.path}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }